module.exports = __webpack_public_path__ + "files/instruction.ff1c06c0.pdf";